import { useTranslation } from 'react-i18next'

import { Card, CardTitle } from '@reveni-io/reveni-ui'

import RelatedInfoItem from './RelatedInfoItem/RelatedInfoItem'
import * as Styles from './styles'

const RelatedInformationCard = ({ items, timeZone }) => {
  const { t } = useTranslation()

  return (
    <Card showBorder={false}>
      <CardTitle>{t('Información relacionada')}</CardTitle>
      {items?.length > 0 && (
        <Styles.ItemsContainer>
          {items.map(item => (
            <RelatedInfoItem
              key={item.linkUrl}
              icon={item.icon}
              label={item.label}
              linkText={item.linkText}
              linkUrl={item.linkUrl}
              chip={item.chip}
              date={item.date}
              timeZone={timeZone}
            />
          ))}
        </Styles.ItemsContainer>
      )}
    </Card>
  )
}

export default RelatedInformationCard
